import Administrator from "./Administrator";
import SuperAgent from "./SuperAgent";

const CreateComponent = {
  Administrator,
  SuperAgent,
};

export default CreateComponent;
